module.exports = __webpack_public_path__ + "141d4a85/img/trash-icon.ff8201c7.svg";